import { getNecessaryCookieWithKey } from 'src/cookies/cookie-types/necessary-cookies';
import type { Cookie } from 'src/cookies/index';

const COOKIE_CONSENT_DISMISSED_COOKIE_NAME = 'cookieconsent_dismissed';

export const COOKIE_CONSENT_DISMISSED_COOKIE: Cookie = getNecessaryCookieWithKey(
  COOKIE_CONSENT_DISMISSED_COOKIE_NAME
);
